// Material-ui
import { createMuiTheme } from '@material-ui/core';
/**
 * Get theme
 */
export function getTheme(themeOptions) {
    if (themeOptions) {
        return createMuiTheme(themeOptions);
    }
    return;
}
//# sourceMappingURL=theme.js.map